import Misc from "./scripts/misc";
import Animations from "./scripts/animations";
import CookieBanner from "./scripts/cookie";

const misc = new Misc();
const animations = new Animations();
const cookieBanner = new CookieBanner();

document.addEventListener("DOMContentLoaded", () => {
    misc.init();
    animations.init();
    cookieBanner.init();
});
